import React, {
    useState,
} from 'react';

import { createBookmark } from './hook';
import {
    CountrySelector,
    CategorySelector,
    SourceSelector,
    SearchForm,
    SearchTitleForm,
    LanguageSelector,
    SortSelector,
    TimeSelector,
} from './selector';


export function Top({
    query: {
        category: defaultCategory = "",
        country: defaultCountry = "us",
        source: defaultSource = [],
        search: defaultSearch = "",
    },
    updateQuery,
}) {
    const [category, changeCategory] = useState(defaultCategory);
    const [country, changeCountry] = useState(defaultCountry);
    const [source, changeSource] = useState(defaultSource);
    const [search, changeSearch] = useState(defaultSearch);

    const submit = () => {
        updateQuery({
            type: 'top',
            category,
            country,
            source,
            search,
        });
    }
    const save = () => {
        createBookmark(
            Object.assign(
                { type: 'top' },
                category && {category},
                country && {country},
                source && source.length > 0 && {source},
                search && {search},
            )
        )
    }
    return (
        <>
        <CategorySelector category={category} changeCategory={changeCategory} />
        <CountrySelector country={country} changeCountry={changeCountry} />
        <SourceSelector source={source} changeSource={changeSource} country={country} category={category} />
        <SearchForm search={search} changeSearch={changeSearch} submit={submit} save={save} />
        </>
    );
}

export function Everything({
    query: {
        search: defaultSearch = "",
        searchInTitle: defaultSearchInTitle = "",
        language: defaultLanguage = "",
        sortBy: defaultSortBy = "publishedAt",
        source: defaultSource = [],
        from: defaultFrom = "",
        to: defaultTo = "",
    },
    updateQuery,
}) {
    const [search, changeSearch] = useState(defaultSearch);
    const [searchInTitle, changeSearchInTitle] = useState(defaultSearchInTitle);
    const [language, changeLanguage] = useState(defaultLanguage);
    const [sortBy, changeSortBy] = useState(defaultSortBy);
    const [source, changeSource] = useState(defaultSource);
    const [from, changeFrom] = useState(defaultFrom);
    const [to, changeTo] = useState(defaultTo);
    const submit = () => {
        updateQuery({
            type: 'everything',
            search,
            searchInTitle,
            language,
            sortBy,
            source,
            from,
            to,
        });
    }
    const save = () => {
        createBookmark(
            Object.assign(
                { type: 'everything' },
                language && {language},
                sortBy && {sortBy},
                search && {search},
                searchInTitle && {searchInTitle},
                from && {from: from},
                to && {to: to},
            )
        )
    }
    return (
        <>
        <LanguageSelector language={language} changeLanguage={changeLanguage} />
        <SortSelector sort={sortBy} changeSort={changeSortBy} />
        <SourceSelector source={source} changeSource={changeSource} language={language} />
        <TimeSelector from={from} changeFrom={changeFrom} to={to} changeTo={changeTo} />
        <SearchTitleForm
            search={search} changeSearch={changeSearch}
            searchInTitle={searchInTitle}
            changeSearchInTitle={changeSearchInTitle}
            submit={submit} save={save}
        />
        </>
    );
}
